import { RDFertilizerEvent } from '@cibo/core'
import { Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface FertilizerCellDisplayProps {
  value: any
}

export const FertilizerCellDisplay = ({ value }: FertilizerCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/FertilizerEditor')

  if (value?.input?.events?.length) {
    return (
      <Tooltip
        title={
          <Stack spacing={1} padding={1}>
            {value.input?.events.map(
              (
                { date, type, nitrogenAmnt, product, rate, units }: RDFertilizerEvent,
                index: number
              ) => (
                <Stack key={index}>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    {t('eventDate', { date: new Date(date) })}
                  </Typography>
                  <Typography variant="body2">
                    {type === 'other'
                      ? product
                        ? `${product} (${t('other')})`
                        : t('other')
                      : t(type)}
                    {' - '}
                    {nitrogenAmnt
                      ? t('amntLbsNac', { value: nitrogenAmnt })
                      : t('applicationRateDisplay', {
                          rate: rate,
                          units: t(units),
                        })}
                  </Typography>
                </Stack>
              )
            )}
          </Stack>
        }
      >
        <Stack>
          <Typography variant="body1">
            {t('events', { count: value.input?.events?.length })}
          </Typography>
          {value.result && (
            <Typography variant="body2" color="text.secondary">
              {t('totalAmntLbsNac', { value: value.result })}
            </Typography>
          )}
        </Stack>
      </Tooltip>
    )
  }

  return <Typography>{t('none')}</Typography>
}
